//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 12/07/2025
// Version : 1
// Description : Evolución mensual de articulos despachados desde x taller.
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Autocomplete,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { Snackbar, Alert } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Dialog_evolucion from "./Dialog_evolucion";

function Evolucion_mensual(props) {
  const [datosGrafico, setDatosGrafico] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  //alertas
  const [openSnack, setOpenSnack] = useState(false);
  const [mensajeSnack, setMensajeSnack] = useState("");
  const [severitySnack, setSeveritySnack] = useState("error");

  const [selectedDate, setSelectedDate] = useState(dayjs());

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  //------------------ Dialog --------------------------//
  const [abrirDialog, setAbrirDialog] = useState(false);

  const handleOpenDialog = () => {
    setAbrirDialog(true);
  };

  const handleCloseDialog = () => {
    setAbrirDialog(false);
  };

  // sucursales
  const [sucursalesDisponibles, setSucursalesDisponibles] = useState(
    props.sucursalesDisponibles
  );
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);

  const handleBuscar = () => {
    const sucursal = sucursalesSeleccionadas[0];
    if (!sucursal) {
      setMensajeSnack("Debe seleccionar una sucursal.");
      setSeveritySnack("error");
      setOpenSnack(true);
      return;
    }

    const fecha = selectedDate.format("YYYY-MM");

    fetch(
      `${UrlApi}/estadisticas/transferenciasEnviadas/${sucursal.id}/${fecha}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) {
          console.error("Respuesta inválida del servidor:", data);
          setMensajeSnack("Error en los datos recibidos.");
          setSeveritySnack("error");
          setOpenSnack(true);
          return;
        }

        const { dataset } = transformarDatosParaBarChart(data);

        const hayDatos = dataset.some((mes) =>
          Object.values(mes)
            .filter((v) => typeof v === "number")
            .some((cantidad) => cantidad > 0)
        );

        if (!hayDatos) {
          setMensajeSnack("No hay resultados encontrados.");
          setSeveritySnack("error");
          setOpenSnack(true);
          return;
        }

        // Si hay datos válidos:
        setDatosGrafico(data);
        setBusquedaRealizada(true);
        setAbrirDialog(true);
      });
  };

  useEffect(() => {
    if (sucursalesSeleccionadas.length > 0) {
    }
  }, [selectedDate, sucursalesSeleccionadas]);

  // console.log("DATOS GRAFICO", datosGrafico);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const transformarDatosParaBarChart = (data) => {
    const articulos = Array.from(
      new Set(data.map((item) => item.nombre_articulo))
    );

    const mes = selectedDate.format("MMMM");

    const fila = { mes };

    articulos.forEach((articulo) => {
      const encontrado = data.find((item) => item.nombre_articulo === articulo);
      fila[articulo] = encontrado ? encontrado.total_enviado : 0;
    });

    return {
      dataset: [fila],
      articulos,
    };
  };

  const { dataset, articulos } = transformarDatosParaBarChart(datosGrafico);

  return (
    <div>
      <Grid container padding={3} spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: "bold",
              fontSize: 20,
              flexGrow: 1,
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            Evolución mensual de despachos
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <DatePicker
              views={["year", "month"]}
              format="YYYY MMMM"
              value={selectedDate}
              onChange={handleDateChange}
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    width: "200px",
                    backgroundColor: "white", // Fondo blanco
                    borderRadius: "4px",
                    "& .MuiInputBase-input": {
                      backgroundColor: "white", // Asegura que el input también sea blanco
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
          {/* SUCURSAL */}
          <Box marginBottom={2} marginTop={2}>
            <Autocomplete
              size="small"
              options={props.sucursalesDisponibles}
              value={sucursalesSeleccionadas[0] || null}
              onChange={(event, value) => {
                setSucursalesSeleccionadas(value ? [value] : []);
                setDatosGrafico([]);
                setBusquedaRealizada(false);
              }}
              getOptionLabel={(option) => `${option.id} - ${option.nombre}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sucursal"
                  placeholder="Tipee para buscar..."
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    "& .MuiInputLabel-root": { color: "black" },
                    "& fieldset": { borderColor: "black" },
                  }}
                />
              )}
            />
          </Box>
          {/* BOTÓN */}
          <Box display="flex" justifyContent="center" marginTop={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBuscar}
              sx={{ height: 40 }}
            >
              Generar Gráfico
            </Button>
          </Box>
        </Grid>
      </Grid>
      {abrirDialog ? (
        <Dialog_evolucion
          abrirDialog={abrirDialog}
          onClose={handleCloseDialog}
          datosGrafico={dataset}
          articulos={articulos}
          sucursalesSeleccionadas={sucursalesSeleccionadas}
        />
      ) : null}
      <Snackbar
        open={openSnack}
        autoHideDuration={4000}
        onClose={() => setOpenSnack(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={severitySnack} onClose={() => setOpenSnack(false)}>
          {mensajeSnack}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Evolucion_mensual;
